var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21847C;}\n\t.st1{fill:#AFCABA;}\n\t.st2{fill:none;stroke:#AFCABA;stroke-width:3.1564;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,46c0,0,8.4-0.5,8.6-7.9c0.3-7.3-7.6-11.3-13.9-10.5s-16,8.6-16.2,24.3s7.6,23.4,15.2,22.9 s9.8-5.1,10.3-6.9c0.5-1.8-0.1-5.6-2.6-8.6c-2.5-3,1-3.5,0.8-7.3C44.3,48.2,40.7,47.6,42.4,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53,91.8V57.7c0,0-0.9-5.1-9.6-4.7c0,0,6.2-0.7,10.1-6.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.9,46c0,0-8.4-0.5-8.6-7.9s7.6-11.3,13.9-10.5s16,8.6,16.2,24.3s-7.6,23.4-15.2,22.9 c-7.6-0.5-9.8-5.1-10.3-6.9c-0.5-1.8,0.1-5.6,2.6-8.6c2.5-3-1-3.5-0.8-7.3C71,48.2,74.6,47.6,72.9,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,91.8V57.7c0,0,0.9-5.1,9.6-4.7c0,0-6.2-0.7-10.1-6.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidney);
export default __webpack_public_path__ + "static/media/Kidney.93b0a6e45bc1ceadf716a3831d564461.svg";
export { ForwardRef as ReactComponent };